import uly from "ulysses/base";
import $ from "jquery";
import ko from "knockout";
import markup from "ulysses/widgets/static.html";
import "../widgets";

$(document).ready(function() { $(markup).appendTo($("body")); });
var edit_settings = function edit_settings(current_data) {
    var res = Promise.Deferred();
    var cdata = $.extend({"show_header": true, "html": ""}, ko.toJS(current_data));
    cdata.columns = ko.observable(ko.unwrap(cdata.columns) || 1);
    var dialog = uly.dialogs.execute($("#static-settings-editor-tmpl").html(), {
        "title":_("static_html_title_edit_html_markup", "Edit HTML Markup")
    }, cdata).done(function([result]) {
        res.resolve({
            "html":ko.unwrap(result.html) || "",
            "show_header":ko.unwrap(result.show_header),
            "columns": ko.unwrap(cdata.columns)
        });
    }).fail(res.reject);
    return res.promise();
};

ko.bindingHandlers.static_html_widget = {
    "initial_value":function(){
        var data = { "html":ko.observable(_("static_html_h_static_text_h", "<h1>Static Text</h1>")), "show_header": ko.observable(true) };
        var init_def = Promise.Deferred();
        edit_settings(data).done(function(result) {
            data.html(result.html);
            init_def.resolve(data);
        }).fail(init_def.reject);
        return init_def;
    },
    "init":function(elt, va, bindings, model, context) {
        var widget_model = ko.unwrap(va());
        widget_model.icon("fa fa-edit");
        widget_model.error = ko.observable(null);

        var settings_menu = widget_model.settings_menu;
        settings_menu.push({
            "caption":_("static_html_caption_modify", "Modify"), 
            "icon":"fa-edit", 
            "action":function(e){
                var cdata = ko.unwrap(widget_model.settings);
                edit_settings(cdata).done(function(result) {
                    widget_model.settings(result);
                    uly.publish("page.savesettings");
                });
            },
            "colour":"default",
            "permission": "editpage"
        });
        
        var settings = ko.unwrap(widget_model.settings);
        $.each({"html":ko.observable(_("static_html_h_page_not_found_h", "<h1>Page Not Found</h1>")), "show_header": ko.observable(false) }, function(key,value) {
            if (typeof settings[key] == "undefined")
                settings[key] = value;
        });
        uly.subscribe("widget.remove", function(topic, widget) {
            if (widget != elt)
                return false;
            ko.removeNode(elt);
        }, elt);

        $(elt).parent().click(function(ev, ui) {
            if (ev.ctrlKey) {
                widget_model.show_header(!widget_model.show_header());
                if (!widget_model.show_header())
                    widget_model.panel_class(widget_model.panel_class().replace("box-primary", "box-no-header"));
                else
                    widget_model.panel_class(widget_model.panel_class().replace("box-no-header", "box-primary"));
            }
        });
        return { controlsDescendantBindings: true };
    },
    "update":function(elt, va, bindings, model, context) {
        var widget_model = ko.unwrap(va());
        var settings = ko.unwrap(widget_model.settings);
        var html = ko.unwrap(settings.html) || "";
        if (elt.nodeType === 8) {
            ko.virtualElements.emptyNode(elt);
            var parsedNodes = ko.utils.parseHtmlFragment(html);
            if (parsedNodes) {
                var endCommentNode = elt.nextSibling;
                for (var i = 0, j = parsedNodes.length; i < j; i++)
                    endCommentNode.parentNode.insertBefore(parsedNodes[i], endCommentNode);
            }
        } else { // plain node
            ko.bindingHandlers.html.update(elt, function() { return html; });
        }
        if (!ko.unwrap(settings.show_header)) {
            widget_model.show_header(false);
            widget_model.panel_class(widget_model.panel_class().replace("box-primary", "box-no-header"));
        }
        try {
            /*if (_with) {
                ko.bindingHandlers.with.init(
                    elt, function() { return bindings().bindwith; }, 
                    function() { return { "with": bindings().bindwith }; }, 
                    model, context);
                //ko.bindingHandlers.with.update(elt, function() { return bindings().bindwith; }, function() { return { "with": bindings().bindwith } }, model, context);
            }
            else{
            */
                ko.applyBindingsToDescendants(context, elt);
            //}
        }
        catch(e) {
            console.error("Error binding html:", e);
        }
    }
};
ko.virtualElements.allowedBindings.static_html_widget = true;

uly.widgets.register({
    "type":"static",
    "caption":_("static_html_caption_static_text", "Static Text"), 
    "description":_("static_html_description_a_static_text_widget", "A static text widget"), 
    "icon":"fa-edit", 
    "init":ko.bindingHandlers.static_html_widget.initial_value,
    "colour":"teal-blue",
    "actions":[{
        "caption":_("static_html_caption_settings", "Settings"), 
        "icon":"fa-cog", 
        "action":function(e){
            return false;
        },
        "colour":"default"
    }]
});

export default {
    configure_html: edit_settings
};
